import React from "react";
import { IWithAuthProps } from "shared-auth";
import { HALManager, UserManager } from "core";
import { FetchInterceptor, IRequestObject } from "shared/utils/http";

import {
  getApiUrl,
  getLiteAgentApiUrl,
  getSearchAndFiltersApiUrl,
  getShortlistsApiUrl,
} from "services/UrlBuilder";

export default function withIdentification<P extends IWithAuthProps>(
  WrappedComponent:
    | React.ComponentClass<P>
    | React.FC<React.PropsWithChildren<P>>
): typeof React.Component {
  return class extends React.Component<P> {
    constructor(props: Readonly<P>) {
      super(props);
      this.registerFetchInterceptor();
    }

    public render() {
      return <WrappedComponent {...this.props} />;
    }

    private registerFetchInterceptor = () => {
      FetchInterceptor.register({
        request: this.requestHandler,
      });
    };

    private requestHandler = (request: IRequestObject) => {
      const { auth } = this.props;
      const requestUrl = request.url?.toLowerCase();

      const isProfileApiRequest =
        requestUrl.includes(getApiUrl().toLocaleLowerCase()) &&
        !requestUrl.includes(HALManager.getFacetCategoriesUrl());
      const isLiteAgentApi = requestUrl.includes(
        getLiteAgentApiUrl().toLocaleLowerCase()
      );
      const isShortListApi = requestUrl.includes(
        getShortlistsApiUrl().toLocaleLowerCase()
      );
      const isSearchAndFiltersApi = requestUrl.includes(
        getSearchAndFiltersApiUrl().toLocaleLowerCase()
      );

      const useAuthHeaders =
        isProfileApiRequest ||
        isLiteAgentApi ||
        isShortListApi ||
        isSearchAndFiltersApi;
      const authHeader = `Bearer ${auth.user?.access_token}`;

      if (auth.isAuthenticated && request.config && useAuthHeaders) {
        const headers: any = {
          Authorization: authHeader,
          "Content-Type": "application/json",
        };

        if (isProfileApiRequest) {
          headers["X-Spotlight-Performer"] = UserManager.artistRef;
        }

        request.config.headers = { ...request.config.headers, ...headers };
      } else if (isProfileApiRequest && request.config) {
        request.config.headers = {
          ...request.config.headers,
          ...({
            Authorization: authHeader,
            "X-Spotlight-Performer": UserManager.artistRef,
            "Content-Type": "application/json",
          } as any),
        };
      }

      return request;
    };
  };
}
